import { useLang } from "@/i18n/LanguageContext";

export default function Process() {
  const { t } = useLang();
  return (
    <section id="process" className="py-24 lg:py-32 bg-[#F9FAFB]" data-testid="process-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-16">
          <p className="bbm-eyebrow mb-4">— {t.process.eyebrow}</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#0B132B] leading-tight tracking-tight">
            {t.process.title}
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#E5E7EB] border border-[#E5E7EB] rounded-lg overflow-hidden">
          {t.process.steps.map((step, i) => (
            <div
              key={i}
              className="bg-white p-8 relative"
              data-testid={`process-step-${i}`}
            >
              <div className="font-mono text-xs text-[#0047FF] tracking-widest mb-6">
                STEP / {step.n}
              </div>
              <div className="w-12 h-px bg-[#FFB800] mb-6" />
              <h3 className="font-display text-xl text-[#0B132B] mb-3">{step.title}</h3>
              <p className="text-[#4B5563] text-sm leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
